import '@styles/Banner/ConfirmacionNewsletters.scss';
import { Link } from '@lana-ui/common';

const ConfirmacionNewsletters = () => {
    return (
        <div className="newsletter col-12">
            También podés suscribirte a nuestros <span className='--font-bold'>Newsletters</span> para manterte
            informado, haciendo <Link target="_blank" className="ln-link --font-bold" href="https://newsletter.lanacion.com.ar/#/" text="click aquí" />
        </div>
    )
}

export default ConfirmacionNewsletters;